export const en = {
  filterButton: 'Filter',
  projectId: 'Project',
  requesterId: 'Reported by',
  priorityId: 'Severity',
  assignedUserId: 'Assigned to',
  status: 'Status',
  FilterBy: 'Filter by: ',
  search: 'Search',
  clear: 'Clear',
  retry: 'Retry',
  dueAt: 'Due date',
  updatedAt: 'Last updated',
  createdAt: 'Report date'
};

export type Translations = typeof en;
